import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Experience.css';
import {
    FaLaptopCode, FaServer, FaDatabase, FaLinux, FaNetworkWired,
    FaProjectDiagram, FaChalkboardTeacher, FaUsers
} from 'react-icons/fa';
import { SiDotnet, SiRedhat } from 'react-icons/si';

const Experience = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            easing: 'ease-out-cubic',
        });
    }, []);

    const experiences = [
        {
            id: 1,
            icon: <SiDotnet />,
            title: "Web Development Using .NET Intern",
            subtitle: "Information Technology Institute (ITI)",
            period: "Aug 2025 — Sep 2025",
            type: "Internship",
            description: "Completed 120-hour intensive training program covering Database Fundamentals, C#, Entity Framework, and ASP.NET Core MVC.",
            highlights: [
                {
                    icon: <FaDatabase />,
                    title: "Database Mastery",
                    description: "Mastered database design, SQL queries, stored procedures, and ORM concepts with Code-First approach."
                },
                {
                    icon: <FaLaptopCode />,
                    title: "MVC Development",
                    description: "Built dynamic web applications using MVC pattern, Razor views, routing, and dependency injection."
                },
                {
                    icon: <FaProjectDiagram />,
                    title: "Graduation Project",
                    description: "Developed graduation project implementing advanced architecture patterns and clean code principles."
                }
            ],
            tags: ["ASP.NET Core", "Entity Framework", "SQL Server", "MVC", "C#"]
        },
        {
            id: 2,
            icon: <SiRedhat />,
            title: "Linux Red Hat Administration Intern",
            subtitle: "National Telecommunication Institute (NTI)",
            period: "Jul 2025 — Aug 2025",
            type: "Internship",
            description: "Completed 120-hour training program (90 hours technical, 30 hours professional development) achieving 77.5% final score.",
            highlights: [
                {
                    icon: <FaLinux />,
                    title: "System Administration",
                    description: "Gained hands-on experience with RHEL command-line operations, file management, and system security."
                },
                {
                    icon: <FaNetworkWired />,
                    title: "Network & Security",
                    description: "Configured user and group management, storage systems, network settings, SELinux, and firewall rules."
                },
                {
                    icon: <FaServer />,
                    title: "Virtualization",
                    description: "Practiced extensively with virtual machines and remote labs preparing for RHCSA (EX200) certification."
                }
            ],
            tags: ["RHEL", "System Admin", "Security", "Network Config", "Bash"]
        },
        {
            id: 3,
            icon: <FaUsers />,
            title: "Backend .NET Developer Trainee",
            subtitle: "IEEE Kafrelshiekh Student Branch",
            period: "Nov 2024 — Jan 2025",
            type: "Trainee",
            description: "Selected through competitive process for intensive backend development training program.",
            highlights: [
                {
                    icon: <FaChalkboardTeacher />,
                    title: "Training Program",
                    description: "Selected through competitive process for intensive backend development training program."
                },
                {
                    icon: <FaLaptopCode />,
                    title: "System Development",
                    description: "Developed Task Management System implementing authentication, authorization, and database architecture."
                },
                {
                    icon: <FaUsers />,
                    title: "Collaboration",
                    description: "Collaborated with team members on project requirements and delivered complete system within internship period."
                }
            ],
            tags: ["Backend", ".NET", "Authentication", "Teamwork"]
        }
    ];

    return (
        <section className="experience" id="experience">
            <div className="experience-background">
                <div className="gradient-orb orb-1"></div>
                <div className="gradient-orb orb-2"></div>
            </div>

            <div className="container experience-container">
                <div className="section-header" data-aos="fade-up">
                    <h2 className="section-title">
                        Work <span className="gradient-text">Experience</span>
                    </h2>
                    <p className="section-subtitle">
                        My professional journey and key projects
                    </p>
                </div>

                <div className="experiences-timeline">
                    {experiences.map((exp, index) => (
                        <div
                            className="experience-item"
                            key={exp.id}
                            data-aos="fade-up"
                            data-aos-delay={index * 100}
                        >
                            <div className="experience-card">
                                <div className="experience-header">
                                    <div className="experience-icon-wrapper">
                                        <div className="experience-icon">{exp.icon}</div>
                                    </div>
                                    <div className="experience-title-section">
                                        <div className="experience-meta">
                                            <span className="experience-type">{exp.type}</span>
                                            <span className="experience-period">{exp.period}</span>
                                        </div>
                                        <h3 className="experience-title">{exp.title}</h3>
                                        <p className="experience-subtitle">{exp.subtitle}</p>
                                    </div>
                                </div>

                                <p className="experience-description">{exp.description}</p>

                                <div className="experience-highlights">
                                    {exp.highlights.map((highlight, idx) => (
                                        <div className="highlight-item" key={idx}>
                                            <div className="highlight-item-icon">{highlight.icon}</div>
                                            <div className="highlight-item-content">
                                                <h4 className="highlight-item-title">{highlight.title}</h4>
                                                <p className="highlight-item-description">{highlight.description}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="experience-tags">
                                    {exp.tags.map((tag, idx) => (
                                        <span className="tag" key={idx}>{tag}</span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Experience;
